const integerSort = (a, b) => parseInt(a, 10) - parseInt(b, 10);


export {integerSort};  // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./src/utils/sorting.js